import { TableCell, TableRow } from '@material-ui/core';
import React, { useState, useEffect, useMemo, useRef, useContext, memo } from "react";
//import { Draggable, DraggableProvided as draggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ReorderIcon from '@material-ui/icons/Reorder';
import { Form, Button, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { InputNumber, Row, Tooltip } from "antd";
import { updatePositionAction, chanageBasketAction, removeBasketAction, placeOrdersAction, getInstrumentConfigAction } from "../../../../redux/actions/brokerAction";
import AddBasketModal from "./addBasketModal";
import ColumnResize from "react-table-column-resizer";
import { isEmptyObject, fmt, deleteCookieCredentials, calculatePrice, isProPlan, fmtINR } from "../../../../util/helper";
import AppContext from '../../../../context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PlusMinQty from "../../../utilities/PlusMinQty";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import addBasket from '../../../../assets/icons/basket-add.svg';
import removeBasket from '../../../../assets/icons/basket-remove.svg';
import moment from "moment";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { message } from "../../../../config"
import LegSLTPModal from "./LegSLTPModal";
import AlertMessage from "../../../common/AlertMessage";
import editicon from '../../../../assets/icons/edit.svg';
import { exitPositionAction } from "../../../../redux/actions/packageAction";
import { Bolt } from 'lucide-react';
import { useToast } from 'components/common/custom-toast/Toast';
const initial = {
	stopLossPrice: 0,
	targetPrice: 0,
	trailReferencePoints: 0,
	trailStepPoints: 0,
	profitLockAt: 0,
	profitLockSl: 0,
	profitLockTrailReferencePoints: 0,
	profitLockTrailStepPoints: 0,
	stopLossPriceisEdit: false,
	targetPriceisEdit: false,
	trailReferencePointsisEdit: false,
	trailStepPointsisEdit: false,
	profitLockAtisEdit: false,
	profitLockSlisEdit: false,
	profitLockTrailReferencePointsisEdit: false,
	profitLockTrailStepPointsisEdit: false,
	riskCoverType: 2
};

const MaterialTableGroupRow = ({ checkedId, handleChange, updateBasket, buySellClick, inputValues, info, source, text, index, rowData, columns, isBasketAdded }) => {
	const {
		config: { isDark },
		setConfig
	} = useContext(AppContext);
	const dispatch = useDispatch();
	const suscriptionStatus = useSelector((state) => state?.packages?.suscriptionStatus);

	const valuRef = useRef();
	const rowRef = useRef({});
	const qtyIDRef = useRef({});
	const [selectLot, setselectLot] = useState(0);
	const [formData, setFormData] = useState(initial);
	const [rowAction, setrowAction] = useState({});
	const [accessorKeyD, setaccessorKey] = useState('');
	const [orderQtyAdd, setorderQtyAdd] = useState(0);
	const [orderQtyExit, setorderQtyExit] = useState(0);
	const [orderQtyRisk, setorderQtyRisk] = useState(1);
	const [type, setType] = useState('');
	const [modalShow, setModalShow] = React.useState(false);
	const [basketAdded, setIsAdded] = React.useState(false);
	const [symbolList, setsymbolList] = React.useState({});
	const [strikeList, setstrikeList] = React.useState({});
	const [editFieldsName, seteditFieldsName] = useState("");
	const [priceType, setpriceType] = useState(0);
	const [hoverValue, setHoverValue] = useState('');
	const [isError, seterror] = useState("");
	const [isList, setisList] = useState("");
	const [risk, setrisk] = React.useState({
		ceRiskON: 0,
		ceRiskOFF: 0,
		peRiskON: 0,
		peRiskOFF: 0,
	});
	const [qtyList, setqtyList] = useState([]);
	const [freezqtyList, setfreezqtyList] = useState([]);

	const [optionChainInstrumentsData, setOptionChainInstrumentsData] = useState(
		[]
	);
	const debounceValue = useDebounce(formData, 2000);
	const formRefSL = useRef();
	const formRefTP = useRef();
	const [isLegModalOpen, setIsLegModalOpen] = useState(false);
	const [modalLegRow, setModalLegRow] = useState(null);
	const toast = useToast()


	useEffect(() => {
		let val = "";
		document.addEventListener("click", function (event) {
			val = qtyIDRef.current;
			//if(event.target.name == "orderQty") {

			if (val != event.target.id) {
				setisList("");
			}

			//

			//}
		});
	}, []);


	useEffect(() => {
		if (rowData) {
			const value = {
				stopLossPrice: rowData.rms?.stopLoss ? rowData.rms.stopLoss.toFixed(2) : 0,
				targetPrice: rowData.rms?.target ? rowData.rms?.target.toFixed(2) : 0,
				trailReferencePoints: rowData.rms?.trailSL?.reference ? rowData.rms?.trailSL?.reference.toFixed(2) : 0,
				trailStepPoints: rowData.rms?.trailSL?.step ? rowData.rms?.trailSL?.step.toFixed(2) : 0,
				profitLockAt: rowData.rms?.profitLockAt ? rowData.rms?.profitLockAt.toFixed(2) : 0,
				profitLockSl: rowData.rms?.profitLockSl ? rowData.rms?.profitLockSl.toFixed(2) : 0,
				profitLockTrailReferencePoints: rowData.rms?.profitLockTrail?.reference ? rowData.rms?.profitLockTrail?.reference.toFixed(2) : 0,
				profitLockTrailStepPoints: rowData.rms?.profitLockTrail?.step ? rowData.rms?.profitLockTrail?.step.toFixed(2) : 0,
				riskCoverType: rowData.rms?.basis === 1 ? "Comb Prem" : "PNL",

			};


			const netQuantity = Math.abs(rowData.netQuantity / rowData.instrument.lotSize);

			if (netQuantity === 1) {
				setqtyList(['1', '1', '1', '1'])
			}
			if (netQuantity >= 2 && netQuantity <= 2) {
				setqtyList(['1', '1', '1', '2'])
			}
			if (netQuantity >= 3 && netQuantity <= 3) {
				setqtyList(['1', '1', '2', '3'])
			}
			if (netQuantity >= 4) {
				setqtyList(['1', '2', '3', netQuantity])
			}

			setfreezqtyList([netQuantity])
			setorderQtyExit(netQuantity)
			setorderQtyRisk(netQuantity)

			if (rowRef.current && Object.keys(rowRef.current).length > 0 && rowRef.current.userAddNetqty) {
				if (rowData.id === rowRef.current.id) {
					setorderQtyAdd(rowRef.current.userAddNetqty)

					// setorderQtyExit(rowRef.current.userExitNetqty)
					// setorderQtyRisk(rowRef.current.userRiskNetqty)
				}

			} else {
				rowRef.current = rowData;
				// rowRef.current.userAddNetqty = netQuantity;
				// rowRef.current.userExitNetqty = netQuantity;
				// rowRef.current.userRiskNetqty = netQuantity;
				setorderQtyAdd(netQuantity)
				// setorderQtyExit(netQuantity)
				// setorderQtyRisk(netQuantity)
			}



			setFormData(value);
		}


	}, [rowData, updateBasket])

	useEffect(() => {

		// updatePositionFun(formData, rowData.id);
		// seteditFieldsName("");
	}, [debounceValue]);


	const handleKeyDown = (e, row) => {
		if (e.key === "Enter") {
			seteditFieldsName("");
			//updateFieldValue(e.target.name, formData, index, row);
			updateSLTP(row)
		}
	}

	const updateSLTP = (rowData) => {

		if (!isValidsltp("sl", rowData, formData.stopLossPrice)) {
			return
		}

		if (!isValidsltp("tp", rowData, formData.targetPrice)) {
			return
		}

		var stopLossPricePr = 0;
		var targetPricePr = 0;
		var ltpVal = document.getElementById("ltp-" + rowData.instrumentToken + "-" + rowData.basketId)?.innerText || document.getElementById("ltp-" + rowData.instrumentToken)?.innerText;

		if (priceType === 0) {
			stopLossPricePr = parseFloat(formData.stopLossPrice)
		} else if (priceType === 1) {
			if (25 > 0) {
				stopLossPricePr = parseFloat(rowData.ltp) - ((formData.stopLossPrice / 100) * parseFloat(rowData.ltp))
			} else if (rowData.netQuantity < 0) {
				stopLossPricePr = parseFloat(rowData.ltp) + ((formData.stopLossPrice / 100) * parseFloat(rowData.ltp))
			} else {
				return;
			}
		} else if (priceType === 2) {
			if (rowData.netQuantity > 0) {
				stopLossPricePr = parseFloat(rowData.ltp) - formData.stopLossPrice
			} else if (rowData.netQuantity < 0) {
				stopLossPricePr = parseFloat(rowData.ltp) + formData.stopLossPrice
			} else {
				return;
			}
		}


		//Traget


		if (priceType === 0) {
			targetPricePr = parseFloat(formData.targetPrice)
		} else if (priceType === 1) {
			if (25 > 0) {
				targetPricePr = parseFloat(rowData.ltp) + ((formData.targetPrice / 100) * parseFloat(rowData.ltp))
			} else if (rowData.netQuantity < 0) {
				targetPricePr = parseFloat(rowData.ltp) - ((formData.targetPrice / 100) * parseFloat(rowData.ltp))
			} else {
				return;
			}
		} else if (priceType === 2) {
			if (rowData.netQuantity > 0) {
				targetPricePr = parseFloat(rowData.ltp) + formData.targetPrice
			} else if (rowData.netQuantity < 0) {
				targetPricePr = parseFloat(rowData.ltp) - formData.targetPrice
			} else {
				return;
			}
		}

		valuRef.current = formData;
		if (!formData.stopLossPrice) {
			formData.trailReferencePoints = null;
			formData.trailStepPoints = null;
		} else {
			if (formData.trailReferencePoints && formData.trailStepPoints) {

				formData.trailReferencePoints = parseFloat(formData.trailReferencePoints);
				formData.trailStepPoints = parseFloat(formData.trailStepPoints);

			} else if (formData.trailReferencePoints && !formData.trailStepPoints) {

				formData.trailReferencePoints = parseFloat(formData.trailReferencePoints);
				formData.trailStepPoints = parseFloat(formData.trailReferencePoints);

			} else if (formData.trailStepPoints && !formData.trailReferencePoints) {
				formData.trailReferencePoints = parseFloat(formData.trailStepPoints);
				formData.trailStepPoints = parseFloat(formData.trailStepPoints);
			} else {
				formData.trailReferencePoints = null;
				formData.trailStepPoints = null;
			}

		}
		formData.stopLossPrice = stopLossPricePr === 0 ? parseFloat(formData.stopLossPrice) : stopLossPricePr;
		formData.targetPrice = targetPricePr === 0 ? parseFloat(formData.targetPrice) : targetPricePr;
		formData.riskCoverType = 0;

		// Add profit locking and trailing fields
		if (formData.profitLockAt) {
			formData.profitLockAt = parseFloat(formData.profitLockAt);
		}
		if (formData.profitLockSl) {
			formData.profitLockSl = parseFloat(formData.profitLockSl);
		}
		if (formData.profitLockTrailReferencePoints) {
			formData.profitLockTrailReferencePoints = parseFloat(formData.profitLockTrailReferencePoints);
		}
		if (formData.profitLockTrailStepPoints) {
			formData.profitLockTrailStepPoints = parseFloat(formData.profitLockTrailStepPoints);
		}

		if (rowData.netQuantity != 0) {
			updatePositionFun(formData, rowData.id);
		}

		setaccessorKey("");
		seteditFieldsName("");
		seteditFieldsName("");

	}

	const openLegModal = (row) => {
		setModalLegRow(row);
		setIsLegModalOpen(true);
	}

	const saveLegModal = () => {
		// Modal now handles the API call internally
		// This callback is kept for compatibility but no longer needed
	}

	function useDebounce(cb, delay) {
		const [debounceValue, setDebounceValue] = useState(cb);
		useEffect(() => {
			const handler = setTimeout(() => {
				setDebounceValue(cb);
			}, delay);

			return () => {
				clearTimeout(handler);
			};
		}, [cb, delay]);
		return debounceValue;
	}

	const handleFieldChange = (val, name, rowData) => {

		if (name === "stopLossPrice") {
			if (!isValidsltp("sl", rowData, parseFloat(val))) {
				seterror("sl")
			}
		}
		if (name === "targetPrice") {

			if (!isValidsltp("tp", rowData, parseFloat(val))) {
				seterror("tp")
			}
		}

		const value = {
			...formData,
			[name]: val ? parseFloat(val) : val,

		};

		setTimeout(() => {
			setFormData(value);
		}, 0);

	};



	const handleFieldChangeQty = (e, type, rowData) => {

		if (type === "add") {
			setorderQtyAdd(parseFloat(e.target.value));
			rowRef.current.userAddNetqty = parseFloat(e.target.value);
		} if (type === "risk") {
			if (Math.abs(rowData.netQuantity) >= (rowData.instrument.lotSize * e.target.value)) {
				setorderQtyRisk(parseFloat(e.target.value));
				rowRef.current.userRiskNetqty = parseFloat(e.target.value);
			}
		} else {
			if (Math.abs(rowData.netQuantity) >= (rowData.instrument.lotSize * e.target.value)) {
				setorderQtyExit(parseFloat(e.target.value));
				rowRef.current.userExitNetqty = parseFloat(e.target.value);
			}
		}

	};

	const updatePositionFun = async (value, positionID) => {
		const data = await dispatch(updatePositionAction(positionID, value));
	}

	const onSelectLot = () => {

	}

	const clickAction = (row, accessorKey) => {
		setaccessorKey();
		setaccessorKey(accessorKey);
		seteditFieldsName(accessorKey);
		const value = {
			...formData,
			// stopLossPrice : 0,
			// targetPrice : 0,
		};
		setFormData(value);
	}

	const addBasketHandle = (row) => {
		setType('basket');
		setModalShow(true)
		setrowAction(row);
		handleChange(true, row, '0')
	}


	const exitOrAddOrder = async (order, orderQty, type) => {
		if (type === "exit") {
			try {
				const qtyToExit = parseInt(orderQty) * order.instrument.lotSize;
				await exitPositionAction(order.id, qtyToExit);
				return;
			} catch (error) {
				console.error('Error placing exit order:', error);
				toast.error('Failed to place exit order');
				return;
			}
		}

		var orderType = "";
		var transactionType = "";

		if (type === "reverse") {
			try {
				const qtyToExit = parseInt(orderQty) * order.instrument.lotSize;
				await exitPositionAction(order.id, qtyToExit);

				if (order.netQuantity > 0) {
					transactionType = "SELL";
				} else if (order.netQuantity < 0) {
					transactionType = "BUY";
				}
			} catch (error) {
				console.error('Error exiting position for reverse:', error);
				toast.error('Failed to exit position');
				return;
			}
		} else if (order.netQuantity > 0 && type === "add") {
			transactionType = "BUY";
		} else if (order.netQuantity < 0 && type === "add") {
			transactionType = "SELL";
		}

		let finalOrderType = inputValues.orderType;
		let finalPrice = 0;

		const calculatedPrice = calculatePrice(
			order.ltp,
			inputValues.marketProtect,
			transactionType,
			inputValues.orderType,
			inputValues.marketBuffer
		);
		finalPrice = calculatedPrice ? parseFloat(calculatedPrice.price) : 0;

		if (inputValues.orderType === "Mkt protect" && (inputValues.marketProtect === 0 || (inputValues.marketProtect === undefined && parseFloat(inputValues.marketProtect) === 0))) {
			finalOrderType = "MARKET";
			finalPrice = 0;
		} else {
			finalOrderType = "LIMIT";
		}

		var param = {
			"basketName": "",
			"basketId": order.basketId ? order.basketId : "",
			"stopLossAbsolute": null,
			"takeProfitAbsolute": null,
			"trailReferenceAbsolute": null,
			"trailStepAbsolute": null,
			"orders": [
				{
					exchange: order.instrument.exchange,
					variety: "REGULAR",
					validity: inputValues.validity,
					product: order.product,
					orderType: finalOrderType,
					transactionType: transactionType,
					quantity: type === "reverse" ? Math.abs(parseInt(order.netQuantity)) : parseInt(orderQty) * order.instrument.lotSize,
					price: finalPrice,
					exchangeToken: order.exchangeToken,
					disclosedQuantity: 0,
					stopLossPrice: null,
					targetPrice: null,
					trailReferencePoints: null,
					trailStepPoints: null,
					cellType: order.instrument.instrumentType,
					symbol: info.instrument.instrument,
					expiry: info.instrument.expiry,
					strike: info.instrument.strikePrice,
					lotSize: info.instrument.lotSize
				}
			]
		}

		async function placeOrders(order) {
			await dispatch(placeOrdersAction(order, info?.broker?.id));
		}

		placeOrders(param);
		setorderQtyAdd(0);
		setorderQtyExit(0);
	};

	const handleRowHover = (rowData) => {
		setHoverValue(rowData.id)
	};

	const handleRowHoverLeave = (rowData) => {
		setHoverValue("")
	};

	const buySell = (type, value, tokens, cellType, strike, isBoth, page) => {
		async function getConfig(brokerId, instrumentToken) {
			const data = await dispatch(getInstrumentConfigAction(brokerId, instrumentToken));
			if (data.data && Object.keys(data.data).length > 0) {

				buySellClick(type, value, tokens, cellType, strike, isBoth, page, data.data);

			}
		}

		getConfig(info.broker.id, value.rowData.underlyingInstrumentToken)
		//	
	}

	const isValidsltp = (type, rowData, val) => {
		if (!val) {
			return true;
		}
		if (document.getElementById("ltp-" + rowData.instrumentToken + "-" + rowData.basketId) || document.getElementById("ltp-" + rowData.instrumentToken)) {

			var ltp = (document.getElementById("ltp-" + rowData.instrumentToken + "-" + rowData.basketId)?.innerText || document.getElementById("ltp-" + rowData.instrumentToken)?.innerText)?.replace(',', '');;
			if (type === "sl") {

				if (rowData.netQuantity > 0) {


					if (val < parseFloat(ltp)) {
						seterror("");
						return true
					} else {
						seterror(type);
						return false
					}
				} else {
					if (val > parseFloat(ltp)) {
						seterror("");
						return true
					} else {
						seterror(type);
						return false
					}
				}
			} else {


				if (rowData.netQuantity > 0) {
					if (val > parseFloat(ltp)) {
						seterror("");
						return true
					} else {
						seterror(type);
						return false
					}
				} else {
					if (val < parseFloat(ltp)) {
						seterror("");
						return true
					} else {
						seterror(type);
						return false
					}
				}

			}

		} else {
			return false
		}

	}

	const removeFromBasketHandle = (row) => {
		const params = {

			"clearSlTp": true,
			"positionIds": checkedId.length > 0 ? checkedId : [row.id]
		}
		dispatch(removeBasketAction(params)).then((data) => {

			if (data.status) {
				toast.success("Position removed from basket successfully");
				setIsAdded(true);
				isBasketAdded(basketAdded);
				handleChange(false, {}, '1')
			} else {
				toast.error("Something went wrong");
				setIsAdded(false);

			}
			setModalShow(false);
		}).catch((err) => {


			toast.error("Something went wrong");
		})

	}

	const buySellRisk = async (rowData, type, isClick) => {
		var transactionType = "BUY";
		if (rowData.netQuantity < 0) {
			transactionType = "SELL";
		}

		const instrumentSide = rowData.instrument.instrumentType;

		const placeDirect = async (tokenKey, symbolObjKey) => {
			const token = rowData.risk[tokenKey];
			const symbolObj = rowData.risk[symbolObjKey] || {};
			const lp = rowData.riskltp[token]?.lp;
			const lotSize = symbolObj['lotSize-' + instrumentSide] || rowData.instrument.lotSize;
			const qty = parseInt(orderQtyRisk) * lotSize;

			let finalOrderType = inputValues.orderType;
			let finalPrice = 0;

			const calculatedPrice = calculatePrice(
				lp,
				inputValues.marketProtect,
				transactionType,
				inputValues.orderType,
				inputValues.marketBuffer
			);
			finalPrice = calculatedPrice ? parseFloat(calculatedPrice.price) : 0;

			if (inputValues.orderType === "Mkt protect" && (inputValues.marketProtect === 0 || (inputValues.marketProtect === undefined && parseFloat(inputValues.marketProtect) === 0))) {
				finalOrderType = "MARKET";
				finalPrice = 0;
			} else {
				finalOrderType = "LIMIT";
			}

			try {
				await exitPositionAction(rowData.id, qty);
			} catch (error) {
				console.error('Error exiting position for risk:', error);
				toast.error('Failed to exit position');
				return;
			}

			const param = {
				basketName: "",
				ignoreBasketMove: true,
				basketId: rowData.basketId || "",
				stopLossAbsolute: null,
				takeProfitAbsolute: null,
				trailReferenceAbsolute: null,
				trailStepAbsolute: null,
				orders: [
					{
						exchange: symbolObj['exchange-' + instrumentSide] || rowData.instrument.exchange,
						variety: "REGULAR",
						validity: inputValues.validity,
						product: rowData.product,
						orderType: finalOrderType,
						transactionType: transactionType,
						quantity: qty,
						price: finalPrice,
						exchangeToken: symbolObj['exchangeToken-' + instrumentSide],
						disclosedQuantity: 0,
						stopLossPrice: null,
						targetPrice: null,
						trailReferencePoints: null,
						trailStepPoints: null,
						cellType: instrumentSide,
						symbol: info.instrument.instrument,
						expiry: info.instrument.expiry,
						strike: info.instrument.strikePrice,
						lotSize: lotSize
					}
				]
			};

			dispatch(placeOrdersAction(param, info?.broker?.id));
		};

		if (isClick === "upper") {
			if (instrumentSide === "CE") {
				if (type === "on") {
					await placeDirect('ceRiskONTokenUpper', 'ceRiskONsymbolUpper');
					return;
				} else {
					await placeDirect('ceRiskONTokenUpper', 'ceRiskOFFsymbolUpper');
					return;
				}
			} else {
				if (type === "on") {
					await placeDirect('peRiskONTokenUpper', 'peRiskONsymbolUpper');
					return;
				} else {
					await placeDirect('peRiskONTokenUpper', 'peRiskOFFsymbolUpper');
					return;
				}
			}
		} else {
			if (instrumentSide === "CE") {
				if (type === "on") {
					await placeDirect('ceRiskONToken', 'ceRiskONsymbol');
					return;
				} else {
					await placeDirect('ceRiskONToken', 'ceRiskOFFsymbol');
					return;
				}
			} else {
				if (type === "on") {
					await placeDirect('peRiskONToken', 'peRiskONsymbol');
					return;
				} else {
					await placeDirect('peRiskONToken', 'peRiskOFFsymbol');
					return;
				}
			}
		}
	};
	const addFreezQty = (qty, type) => {
		if (type === "risk") {
			setorderQtyRisk(parseFloat(qty))
		} else if (type === "orderQty") {
			setorderQtyAdd(parseFloat(qty));
		} else {
			setorderQtyExit(parseFloat(qty));
		}

	}

	const openQtyOption = (val) => {
		setisList(val)
		qtyIDRef.current = val;
	}
	return (
		<>
			{/* <Draggable key={"drag-id~"+rowData.id} draggableId={"drag-id~"+rowData.id.toString()} index={index}>
				{(draggableProvided) => ( */}
			<TableRow
				onMouseLeave={(e) => handleRowHoverLeave(rowData)}
				onMouseEnter={(e) => handleRowHover(rowData)}
				key={rowData.id}
				// ref={draggableProvided.innerRef} 
				//  {...draggableProvided.draggableProps}
				className='position-relative'
			>
				<TableCell

					align="left"
					className='dataCell position-relative'
					style={{ padding: '0px', margin: '0px', borderBottom: isDark ? "#0000001a" : "#e0e0e0", ...(isList ? { overflow: "revert-layer" } : {}) }}
				>
					{/* <div {...draggableProvided.dragHandleProps} style={{width:"5px"}}> */}
					{/* <Tooltip title={rowData['displayName'] + ' Click and hold to drag'}>
									<ReorderIcon />
								</Tooltip> */}
					{/* <Tooltip
										placement="top"
										title={rowData.instrument ? rowData?.instrument['displayName'] + ' Click and hold to drag':"Click and hold to drag" }
									> */}
					<FormControlLabel
						control={<Checkbox style={{ padding: 0, margin: 0 }} checked={checkedId.filter((item) => item === rowData.id).length > 0} onChange={(e) => handleChange(e.target.checked, rowData, '0')} name={""} />}
						label={""}
						style={{ padding: 0, margin: 0 }}
					//disabled={true}
					/>
					{/* <ReorderIcon style={{color:isDark ? "#afb2b6": "#000"}}/> */}
					{/* </Tooltip> */}

					{/* </div> */}
				</TableCell>
				{columns.map((obj) => (
					<React.Fragment key={obj.accessorKey}>
						{obj.enableColumn && rowData.instrument &&
							<>
								<TableCell
									className={`
                                   ${rowData.netQuantity !== 0 || obj.accessorKey === "totalPNL"
											? "dataCell position-relative"
											: "disabled-text-color dataCell position-relative"}
                                   ${["tradingSymbol", "displayName"].includes(obj.accessorKey)
											? "sticky-column"
											: ""}
                                 `}

									id={obj.accessorKey + "-" + rowData['instrumentToken'] + "-" + rowData["basketId"]}
									align={obj.align}
									onClick={() => clickAction(rowData, obj.accessorKey + '-' + index)}
									style={{
										whiteSpace: "nowrap",
										...(isList ? { overflow: "revert-layer" } : {})
									}}
								//	onMouseEnter={(e) =>handleCellHover(rowData, obj.accessorKey+'-'+index)} 
								//	style={{minWidth:obj.width}}
								>
									{obj.accessorKey === "riskONriskOff" && rowData.risk ?
										<div style={{ width: "240px", justifyContent: "center" }} className={`d-flex ${rowData.netQuantity === 0 ? "disabled-text-color" : ""}`}>
											<Button onClick={() => buySellRisk(rowData, 'on', "upper")} disabled={!rowData.netQuantity || (!rowData.risk.ceRiskONUpper && !rowData.risk.peRiskONUpper)} size="sm" type="button" variant="outline-danger" className={`outline-danger me-1 p-0`} >

												<Tooltip
													overlayStyle={{ position: 'fixed' }}
													placement="top"
													title={
														rowData.instrument.instrumentType === "CE"
															? fmt(rowData.risk.ceRiskONUpper) : fmt(rowData.risk.peRiskONUpper)
													}
												>
													<KeyboardDoubleArrowLeftIcon />
												</Tooltip>

												{/* <span id={rowData.instrument.strikePrice+"-risk"}>({rowData.riskltp[rowData.risk.ceRiskONToken]?.lp?.toFixed(2)}) </span> */}
											</Button>
											<Button onClick={() => buySellRisk(rowData, 'on', "lower")} disabled={!rowData.netQuantity || (!rowData.risk.ceRiskON && !rowData.risk.peRiskON)} size="sm" type="button" variant="outline-danger" className={`outline-danger me-1 p-0`} >

												<Tooltip
													overlayStyle={{ position: 'fixed' }}
													placement="top"
													title={
														rowData.instrument.instrumentType === "CE"
															? fmt(rowData.risk.ceRiskON) : fmt(rowData.risk.peRiskON)
													}
												>
													<KeyboardArrowLeftIcon />
												</Tooltip>

												{/* <span id={rowData.instrument.strikePrice+"-risk"}>({rowData.riskltp[rowData.risk.ceRiskONToken]?.lp?.toFixed(2)}) </span> */}
											</Button>
											<div className="text-center me-1">
												{/* <InputNumber
												min={0}
												value={rowData.instrument.lotSize}
												onChange={onSelectLot}
												size="small"
												className='me-1'
											/> */}
												<Form.Group className="form-group">
													<Form.Label></Form.Label> <Form.Label className={`custom-label ${rowData.netQuantity === 0 ? "disabled-text-color" : ""}`}> <span>Qty: {rowData.instrument.lotSize * orderQtyRisk}</span></Form.Label>
													<Form.Control id={index + '-riskQty'} onClick={() => openQtyOption(index + '-riskQty')} type="number" placeholder="" step="1" name="orderQty" className={rowData.netQuantity === 0 ? "disabled-text-color" : ""} disabled={rowData.netQuantity === 0} min={1} value={orderQtyRisk} onChange={(e) => handleFieldChangeQty(e, 'risk', rowData)} />
												</Form.Group>
												{index + '-riskQty' === isList &&
													<ul className='cos-drop-list'>
														{qtyList && qtyList.map((item, index) => {
															return (<li key={index} onClick={() => addFreezQty(item, 'risk')}>{item}</li>)
														})}
													</ul>
												}
												{/* <Button size="sm" type="button" className={`btn  btn-success me-1`} onClick={()=>exitOrAddOrder(rowData,orderQtyExit,'exit')}> Add</Button> */}
											</div>
											<Button onClick={() => buySellRisk(rowData, 'off', "lower")} size="sm" disabled={!rowData.netQuantity || (!rowData.risk.ceRiskOFF && !rowData.risk.peRiskOFF)} type="button" variant="outline-success" className={`outline-success me-1 p-0`} >

												<Tooltip
													overlayStyle={{ position: 'fixed' }}
													placement="top"
													title={
														rowData.instrument.instrumentType === "CE"
															? fmt(rowData.risk.ceRiskOFF) : fmt(rowData.risk.peRiskOFF)
													}
												>
													<KeyboardArrowRightIcon />
												</Tooltip>
												{/* <span id={rowData.instrument.strikePrice+"-risk"}>({rowData.riskltp[rowData.risk.peRiskONToken]?.lp?.toFixed(2)})</span> */}
											</Button>
											<Button onClick={() => buySellRisk(rowData, 'off', "upper")} size="sm" disabled={!rowData.netQuantity || (!rowData.risk.ceRiskOFFUpper && !rowData.risk.peRiskOFFUpper)} type="button" variant="outline-success" className={`outline-success me-1 p-0`} >

												<Tooltip
													overlayStyle={{ position: 'fixed' }}
													placement="top"
													title={
														rowData.instrument.instrumentType === "CE"
															? fmt(rowData.risk.ceRiskOFFUpper) : fmt(rowData.risk.peRiskOFFUpper)
													}
												>
													<KeyboardDoubleArrowRightIcon />
												</Tooltip>
												{/* <span id={rowData.instrument.strikePrice+"-risk"}>({rowData.riskltp[rowData.risk.peRiskONToken]?.lp?.toFixed(2)})</span> */}
											</Button>

										</div>
										: obj.accessorKey === "add" ?
											<div className="text-left d-flex posi-inputs" style={{ width: "190px", justifyContent: "center" }}>
												<div className="text-center me-1 addRiskExit position-relative">
													<Form.Group className="form-group">
														<Form.Label></Form.Label> <Form.Label className={`custom-label ${rowData.netQuantity === 0 ? "disabled-text-color" : ""}`}> <span>Qty: {rowData.instrument.lotSize * orderQtyAdd}</span></Form.Label>
														<Form.Control id={index + '-orderQty'} onClick={() => openQtyOption(index + '-orderQty')} type="number" placeholder="" step="1" name="orderQty" className={rowData.netQuantity === 0 ? "disabled-text-color" : ""} disabled={rowData.netQuantity === 0} min={1} value={orderQtyAdd} onChange={(e) => handleFieldChangeQty(e, 'add', rowData)} />

													</Form.Group>

													{index + '-orderQty' === isList &&
														<ul className='cos-drop-list'>
															<li key="qty-1" onClick={() => addFreezQty(parseInt(Math.abs(rowData.netQuantity / rowData.instrument.lotSize)), 'orderQty')}>{parseInt(Math.abs(rowData.netQuantity / rowData.instrument.lotSize))}</li>
															<li key="qty-2" onClick={() => addFreezQty(parseInt(Math.abs((rowData.instrument.volumeFreeze) / rowData.instrument.lotSize)), 'orderQty')}  >{parseInt(Math.abs((rowData.instrument.volumeFreeze) / rowData.instrument.lotSize))}</li>
															<li key="qty-3" onClick={() => addFreezQty(parseInt(Math.abs((rowData.instrument.volumeFreeze / rowData.instrument.lotSize) / 2)), 'orderQty')}   >{parseInt(Math.abs((rowData.instrument.volumeFreeze / rowData.instrument.lotSize) / 2))}</li>
															<li key="qty-4" onClick={() => addFreezQty(parseInt(Math.abs((rowData.instrument.volumeFreeze / rowData.instrument.lotSize) / 4)), 'orderQty')}  >{parseInt(Math.abs((rowData.instrument.volumeFreeze / rowData.instrument.lotSize) / 4))}</li>
															{/* {freezqtyList && freezqtyList.map((item, index)=>{
															return (<li onClick={()=>addFreezQty(item,'risk')}>{item}</li>)
														})} */}
														</ul>
													}
													{/* <select className="form-control">
											<option onClick={()=>addFreezQty(rowData.netQuantity)}>{rowData.netQuantity}</option>
											<option onClick={()=>addFreezQty((rowData.instrument.volumeFreeze)/rowData.instrument.lotSize)}  >{(rowData.instrument.volumeFreeze)/rowData.instrument.lotSize}</option>
											<option onClick={()=>addFreezQty((rowData.instrument.volumeFreeze/2)/rowData.instrument.lotSize)}   >{(rowData.instrument.volumeFreeze/2)/rowData.instrument.lotSize}</option>
											<option onClick={()=>addFreezQty((rowData.instrument.volumeFreeze/4)/rowData.instrument.lotSize)}  >{(rowData.instrument.volumeFreeze/4)/rowData.instrument.lotSize}</option>
									   </select> */}
												</div>
												<Button size="sm" type="button" disabled={rowData.netQuantity == 0} variant="outline-success" className={`text-success me-1`} onClick={() => exitOrAddOrder(rowData, orderQtyAdd, 'add')}> Add</Button>
											</div>
											: obj.accessorKey === "exit" ?
												<div className="text-left d-flex posi-inputs" style={{ width: "190px", justifyContent: "center" }}>
													<div className="text-center me-1">
														<Form.Group style={{ paddingLeft: "0px" }} className="form-group">
															<Form.Label></Form.Label> <Form.Label className={`custom-label ${rowData.netQuantity === 0 ? "disabled-text-color" : ""}`}> <span>Qty: {rowData.instrument.lotSize * orderQtyExit}</span></Form.Label>
															<Form.Control type="number" id={index + '-exitQty'} onClick={() => openQtyOption(index + '-exitQty')} placeholder="" step="1" name="orderQty" className={rowData.netQuantity === 0 ? "disabled-text-color" : ""} disabled={rowData.netQuantity === 0} min={1} value={orderQtyExit} onChange={(e) => handleFieldChangeQty(e, 'exit', rowData)} />
														</Form.Group>

														{index + '-exitQty' === isList &&
															<ul className='cos-drop-list'>

																{qtyList && qtyList.map((item, index) => {
																	return (<li key={index} onClick={() => addFreezQty(item, 'exitQty')}>{item}</li>)
																})}


															</ul>
														}
													</div>
													<Button size="sm" type="button" disabled={rowData.netQuantity == 0} variant="outline-danger" className={` text-danger me-1`} onClick={() => exitOrAddOrder(rowData, orderQtyExit, 'exit')}> Exit</Button>
												</div>
												: obj.accessorKey === "stopLoss" ?
													<span>{rowData.rms?.stopLoss != null && rowData.rms?.stopLoss !== undefined ? fmtINR(rowData.rms?.stopLoss) : '-'}</span>
													: obj.accessorKey === "target" ?
														<span>{rowData.rms?.target != null && rowData.rms?.target !== undefined ? fmtINR(rowData.rms?.target) : '-'}</span>
														: obj.accessorKey === "forEvery" ?
															<span>{(rowData.rms?.trailSL?.reference != null && rowData.rms?.trailSL?.reference !== undefined) || (rowData.rms?.trailSL?.step != null && rowData.rms?.trailSL?.step !== undefined) ? `${(rowData.rms?.trailSL?.reference != null && rowData.rms?.trailSL?.reference !== undefined) ? fmtINR(rowData.rms?.trailSL?.reference) : '-'} / ${(rowData.rms?.trailSL?.step != null && rowData.rms?.trailSL?.step !== undefined) ? fmtINR(rowData.rms?.trailSL?.step) : '-'}` : '-'}</span>
															: obj.accessorKey === "profitLocking" ?
																<span>{(rowData.rms?.profitLockAt != null && rowData.rms?.profitLockAt !== undefined) || (rowData.rms?.profitLockSl != null && rowData.rms?.profitLockSl !== undefined) ? `${(rowData.rms?.profitLockAt != null && rowData.rms?.profitLockAt !== undefined) ? fmtINR(rowData.rms?.profitLockAt) : '-'} / ${(rowData.rms?.profitLockSl != null && rowData.rms?.profitLockSl !== undefined) ? fmtINR(rowData.rms?.profitLockSl) : '-'}` : '-'}</span>
																: obj.accessorKey === "profitTrailing" ?
																	<span>{(rowData.rms?.profitLockTrail?.reference != null && rowData.rms?.profitLockTrail?.reference !== undefined) || (rowData.rms?.profitLockTrail?.step != null && rowData.rms?.profitLockTrail?.step !== undefined) ? `${(rowData.rms?.profitLockTrail?.reference != null && rowData.rms?.profitLockTrail?.reference !== undefined) ? fmtINR(rowData.rms?.profitLockTrail?.reference) : '-'} / ${(rowData.rms?.profitLockTrail?.step != null && rowData.rms?.profitLockTrail?.step !== undefined) ? fmtINR(rowData.rms?.profitLockTrail?.step) : '-'}` : '-'}</span>
																	: obj.accessorKey === "reverse" ?
																		<div className="text-left">
																			<Button size="sm" type="button" disabled={rowData.netQuantity == 0} variant="outline-warning" className={`text-warning me-1`} onClick={() => exitOrAddOrder(rowData, orderQtyExit, 'reverse')}> Reverse</Button>
																		</div>
																		: obj.accessorKey === "riskActions" ?
																			<div className="text-center">
																				<Tooltip
																					overlayStyle={{ position: 'fixed' }}
																					placement="top"
																					title="Edit leg risk settings"
																				>
																					<Bolt
																						className={`risk-settings ${rowData.netQuantity === 0 ? 'disabled-text-color' : ''}`}
																						size={20}
																						strokeWidth={1.5}
																						onClick={() => rowData.netQuantity !== 0 && openLegModal(rowData)}
																						style={{ opacity: rowData.netQuantity === 0 ? 0.5 : 1, cursor: rowData.netQuantity === 0 ? 'not-allowed' : 'pointer' }} />
																				</Tooltip>
																			</div>
																			: obj.accessorKey === "product" ?
																				<div className="text-left">
																					<p className="product-text">{rowData[obj.accessorKey]}</p>
																				</div>
																				: obj.accessorKey === "displayName" ?
																					<div className="text-left">
																						<p className="displayName-text">{rowData.instrument.displayName}</p>
																					</div>
																					: obj.accessorKey === "expiry" ?
																						<span>{moment(rowData.instrument.expiry).format("DD-MMM-YY")}</span>
																						: obj.accessorKey === "instrumentType" ?
																							<span>{rowData.instrument.instrumentType}</span>
																							: obj.accessorKey === "strikePrice" ?
																								<span>{fmt(rowData.instrument.strikePrice)}</span>
																								: obj.accessorKey === "totalPNL" ?
																									<span className={rowData[obj.accessorKey] > 0 ? "text-success" : rowData[obj.accessorKey] < 0 ? "text-danger" : ""}>{rowData[obj.accessorKey] ? fmtINR(rowData[obj.accessorKey]) : 0.00}</span>
																									: obj.accessorKey === "netQuantity" ?
																										<span className={rowData[obj.accessorKey] > 0 ? "text-primary" : rowData[obj.accessorKey] < 0 ? "text-danger" : ""}>{rowData[obj.accessorKey] > 0 ? "+" : rowData[obj.accessorKey] < 0 ? "" : ""}{rowData[obj.accessorKey]}</span>
																										: obj.accessorKey === "realizedPNL" ?
																											<span className={rowData[obj.accessorKey] > 0 ? "text-success" : rowData[obj.accessorKey] < 0 ? "text-danger" : ""}>{rowData[obj.accessorKey] ? fmtINR(rowData[obj.accessorKey]) : 0.00}</span>
																											: obj.accessorKey === "unrealizedPNL" ?
																												<span className={rowData[obj.accessorKey] > 0 ? "text-success" : rowData[obj.accessorKey] < 0 ? "text-danger" : ""}>{rowData[obj.accessorKey] ? fmtINR(rowData[obj.accessorKey]) : 0.00}</span>
																												: obj.accessorKey === "ltp" ?
																													<span id={"ltp-" + rowData['instrumentToken'] + "-" + rowData['basketId']}>{rowData[obj.accessorKey] ? parseFloat(rowData[obj.accessorKey]).toFixed(2) : 0.00}</span>
																													: ["iv", "delta", "theta", "vega", "gamma"].includes(obj.accessorKey) ?
																														<span
																															id={obj.accessorKey + "-" + rowData['instrumentToken'] + "-" + rowData['basketId']}
																															className={obj.accessorKey === "iv" ? "" : (Number(rowData[obj.accessorKey]) === 0 ? "" : (Number(rowData[obj.accessorKey]) > 0 ? "text-success" : "text-danger"))}
																														>
																															{rowData[obj.accessorKey] ? parseFloat(rowData[obj.accessorKey]).toFixed(obj.accessorKey === "gamma" ? 4 : 2) : "0.00"}
																														</span>
																														: obj.accessorKey === "basketName" ?
																															<Tooltip
																																overlayStyle={{ position: 'fixed' }}
																																placement="top"
																																title={rowData[obj.accessorKey]}
																															>
																																<span>
																																	{rowData[obj.accessorKey]?.length >= 15 ? rowData[obj.accessorKey]?.substring(0, 15) + '...' : rowData[obj.accessorKey]}
																																</span>
																															</Tooltip>
																															: obj.accessorKey === "tradingSymbol" ?
																																rowData.instrument.tradingSymbol
																																: obj.accessorKey === "name" ?
																																	rowData.instrument.name
																																	: obj.isDecimal ? rowData[obj.accessorKey] ? parseFloat(rowData[obj.accessorKey]).toFixed(2) : 0.00 : rowData[obj.accessorKey]

									}




								</TableCell>
								{/* <ColumnResize
								id={"fno-table-header-cell"}
								resizeEnd={(width) => console.log("resize end", width)}
								resizeStart={() => console.log("resize start")}
								className="columnResizer"
									
								/> */}
							</>
						}

					</React.Fragment>
				))}
				{/* add ability to spread the remainging table data? */}
				{/* <TableCell>{rowData.description}</TableCell>
						<TableCell align="right">{rowData.unitPrice}</TableCell>
						<TableCell align="right">{rowData.quantity}</TableCell>
						<TableCell align="right">{(rowData.unitPrice * rowData.quantity).toFixed(2)}</TableCell> */}
				{/* Add Edit Delete actions */}
				{/* <TableCell>
							<IconButton size="small">
								<Tooltip title="Edit">
									<EditIcon />
								</Tooltip>
							</IconButton>
						</TableCell>
						<TableCell>
							<IconButton size="small">
								<Tooltip title="Delete">
									<DeleteIcon />
								</Tooltip>
							</IconButton>
						</TableCell> */}

				{(hoverValue === rowData.id) &&
					<TableCell>
						<div style={{ gap: 0 }} className={'bs-btn ltp-b-s-btn active-buy-sell hover-btn pos-icon'}>
							{/* <Button size="sm" type="button" className="btn btn-primary sell-light " onClick={()=>addBasketHandle(rowData)}> */}
							<Tooltip
								overlayStyle={{ position: 'fixed' }}
								placement="top"
								title=" Add to Strategy"
							>
								<img
									src={addBasket}
									alt="delete"
									onClick={() => addBasketHandle(rowData)}
									className='add-basket'

								/>
							</Tooltip>



							{rowData.basketId &&
								// <Button size="sm" type="button" className="btn btn-primary sell-light " onClick={()=>removeFromBasketHandle(rowData)}>R</Button>
								<Tooltip
									overlayStyle={{ position: 'fixed' }}
									placement="top"
									title=" Remove from Strategy"
								>
									<img
										src={removeBasket}
										alt="delete"
										onClick={() => removeFromBasketHandle(rowData)}
										className='remove-basket'

									/>
								</Tooltip>
							}

							<>
								{rowData.netQuantity === 0 && rowData.underlyingInstrumentToken != 0 &&
									<>
										<Button
											size="sm"
											type="button"
											className="btn btn-success buy-light"
											onClick={() => buySell(
												"BUY",
												{ ['lp' + rowData.instrument.instrumentType]: rowData.ltp, rowData: rowData },
												{
													[rowData.instrument.instrumentType]: rowData.instrument.instrumentToken,
													["exchangeToken-" + rowData.instrument.instrumentType]: rowData.instrument.exchangeToken,
													["tradingSymbol-" + rowData.instrument.instrumentType]: rowData.instrument.tradingSymbol,
													["exchange-" + rowData.instrument.instrumentType]: rowData.instrument.exchange,
													["lotSize-" + rowData.instrument.instrumentType]: rowData.instrument.lotSize,
													["displayName-" + rowData.instrument.instrumentType]: rowData.instrument.displayName,
													basketId: rowData.basketId,
												},
												rowData.instrument.instrumentType,
												rowData.instrument.strikePrice,
												false,
												"position"
											)}
										>B</Button>

										<Button
											size="sm"
											type="button"
											className="btn btn-danger sell-light "
											onClick={() => buySell(
												"SELL",
												{ ['lp' + rowData.instrument.instrumentType]: rowData.ltp, rowData: rowData },
												{
													[rowData.instrument.instrumentType]: rowData.instrument.instrumentToken,
													["exchangeToken-" + rowData.instrument.instrumentType]: rowData.instrument.exchangeToken,
													["tradingSymbol-" + rowData.instrument.instrumentType]: rowData.instrument.tradingSymbol,
													["exchange-" + rowData.instrument.instrumentType]: rowData.instrument.exchange,
													["lotSize-" + rowData.instrument.instrumentType]: rowData.instrument.lotSize,
													["displayName-" + rowData.instrument.instrumentType]: rowData.instrument.displayName,
													basketId: rowData.basketId,
												},
												rowData.instrument.instrumentType,
												rowData.instrument.strikePrice,
												false,
												"position"
											)}
										>S</Button>
									</>
								}
							</>
						</div>
					</TableCell>
				}

			</TableRow>
			{/* )}
			</Draggable> */}

			<AddBasketModal checkedId={checkedId} setIsAdded={() => { handleChange(false, {}, '1'); setIsAdded(true); isBasketAdded(basketAdded) }} modalShow={modalShow} setModalShow={setModalShow} type={type} row={rowAction} />
			{isLegModalOpen && (
				<LegSLTPModal
					show={isLegModalOpen}
					setShow={setIsLegModalOpen}
					rowData={modalLegRow}
					onSave={saveLegModal}
				/>
			)}
		</>
	);
};

export default memo(MaterialTableGroupRow);